const investmentFundQuestionLang = {
	you_have_question_on_contact_us: {
		tag: 'investment.fund_question.you_have_question_on_contact_us',
		fr: "Vous avez une question sur <i>{{fund_name}}</i> ? N'hésitez pas à nous contacter.",
		en: 'You have a question on <i>{{fund_name}}</i> ? Feel free to contact us.',
	},
};

export default investmentFundQuestionLang;
